<script setup lang="ts">
import { ecspPersonalComplianceProfileConfig } from '../../../account/personal/complianceProfile/ecspComplianceProfile'
import {
    clearFormValuesNoAnswer,
    getNaturalWidgetFormValidationRules,
    initializeNaturalWidgetForm,
    isRequiredNaturalComplianceProfileAttribute,
} from '../../ESAC/form/forms'
import { enumToSelectOptions } from '../../../../utilities/helpers'
import { computed, watch } from 'vue'
import { App } from '../../../../typings/api-enums'
import { useVModel } from '@vueuse/core'
import BaseInputRadio from '../../../base/BaseInputRadio.vue'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'

const props = defineProps<{
    modelValue: App.Services.ComplianceProfile.ECSP.Categories.Natural.EcspRiskDto
}>()
const emit = defineEmits(['update:modelValue'])
const formValues = useVModel(props, 'modelValue', emit)

const disabled = computed(() => {
    return formValues.value.no_answer === true
})

watch(
    () => formValues.value.no_answer,
    () => {
        clearFormValuesNoAnswer(formValues)
    }
)

initializeNaturalWidgetForm(
    getNaturalWidgetFormValidationRules(
        ecspPersonalComplianceProfileConfig['Risk'].validationKey,
        'ecsp',
        ecspPersonalComplianceProfileConfig['Risk'].denyKey
    ),
    null,
    'ecsp'
)
</script>
<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 py-3">
        <div class="mb-4 flex">
            <BaseInputCheckbox
                v-model="formValues.no_answer"
                :required="isRequiredNaturalComplianceProfileAttribute('risk', 'no_answer')"
                :label="$t('ecsp.natural.risk.no_answer')"
                name="risk.no_answer" />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.startup_investing"
                name="risk.startup_investing"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.StartupInvestingAnswerOption,
                        'ecsp.startup_investing'
                    )
                "
                :label="$t('ecsp.natural.risk.startup_investing')"
                :required="isRequiredNaturalComplianceProfileAttribute('risk', 'startup_investing')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.investments_outside_stock_market"
                name="risk.investments_outside_stock_market"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.InvestmentsOutsideStockMarketAnswerOption,
                        'ecsp.investments_outside_stock_market'
                    )
                "
                :label="$t('ecsp.natural.risk.investments_outside_stock_market')"
                :required="isRequiredNaturalComplianceProfileAttribute('risk', 'investments_outside_stock_market')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.subordinated_financial_instruments"
                name="risk.subordinated_financial_instruments"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.SubordinatedFinancialInstrumentsAnswerOption,
                        'ecsp.subordinated_financial_instruments'
                    )
                "
                :label="$t('ecsp.natural.risk.subordinated_financial_instruments')"
                :required="isRequiredNaturalComplianceProfileAttribute('risk', 'subordinated_financial_instruments')"
                :disabled="disabled"
                vertical />
        </div>

        <div class="flex">
            <BaseInputRadio
                v-model="formValues.profit_participation_certificate"
                name="risk.profit_participation_certificate"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.ProfitParticipationCertificateAnswerOption,
                        'ecsp.profit_participation_certificate'
                    )
                "
                :label="$t('ecsp.natural.risk.profit_participation_certificate')"
                :required="isRequiredNaturalComplianceProfileAttribute('risk', 'profit_participation_certificate')"
                :disabled="disabled"
                vertical />
        </div>
    </div>
</template>
